import { render, staticRenderFns } from "./postalCode.vue?vue&type=template&id=39b6970c&"
import script from "./postalCode.vue?vue&type=script&lang=ts&"
export * from "./postalCode.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports